jQuery(document).ready(function ($) {
    $('#footer-suburb-list-toggle').click(function () {
        $(this).toggleClass('hide-list');
    });

    /**
     * Select 2 search used by header and ausmap search
     */
    $('.services-search').select2({
        placeholder: "Suburb / Postcode",
        templateSelection: function (data) {
            if (data.slug === '') { // adjust for custom placeholder values
                return 'Custom styled placeholder text';
            }

            return data.text;
        },
        ajax: {
            url: function (params) {
                return '/wp-json/fitness-enhancement/suburb-search/' + params.term
            },
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
            },
            dataType: 'json',
            // return null data as it's being sent in the url instead!
            data: function () {
                return null;
            },
        },
    }).on('select2:select', function (e) {
        var data = e.params.data;
        $('.display-postcode').val(data.text);
        $('.suburb-search-form').attr('action', '/services/personal-trainer/' + data.slug);
    });

    $('.suburb-search-form').on('submit', function () {
        if ($(this).attr('action') == '') {
            return false;
        }
    })
    $('.services-search').one('select2:open', function (e) {
        $('input.select2-search__field').prop('placeholder', 'Enter suburb or postcode here to search');
    });
});
